import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { ROUTES } from '../../utils/routes';

const logo = process.env.PUBLIC_URL + '/images/logo.png';

const solutionsItems = [
  // {
  //   label: 'All Solutions',
  //   id: 'solutions',
  //   path: ROUTES.SOLUTIONS,
  //   icon: 'bi-grid-3x3-gap'
  // },
  {
    label: 'SAP Solutions',
    id: 'sap',
    path: ROUTES.SAP_SOLUTIONS,
    icon: 'bi-grid-3x3-gap'
  },
  {
    label: 'Data & AI',
    id: 'data-ai',
    path: ROUTES.AI_SOLUTIONS,
    icon: 'bi-cpu'
  },
  {
    label: 'Blockchain & Web3',
    id: 'blockchain',
    path: ROUTES.BLOCKCHAIN_SOLUTIONS,
    icon: 'bi-diagram-3'
  }
];

const navLinks = [
  { label: 'Industries', path: ROUTES.INDUSTRIES },
  { label: 'Technology Ecosystem', path: ROUTES.TECHNOLOGY_ECOSYSTEM },
  { label: 'Insights', path: ROUTES.INSIGHTS },
  { label: 'Leadership', path: ROUTES.LEADERSHIP },
  { label: 'Careers', path: ROUTES.CAREERS },
  { label: 'About', path: ROUTES.ABOUT },
];

const Navbar = () => {
  const location = useLocation();

  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);

  const solutionsRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        solutionsRef.current &&
        !solutionsRef.current.contains(e.target)
      ) {
        setSolutionsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener(
        'mousedown',
        handleClickOutside
      );
    };
  }, []);

  const handleAnchorScroll = (id) => {
    setSolutionsOpen(false);

    setTimeout(() => {
      const el = document.getElementById(id);

      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }, 100);
  };

  return (
    <header
      className={`ms-header ${scrolled ? 'scrolled' : ''}`}
    >
      <div className="header-inner">
        <div className="container">
          <div className="header-main-row">

            {/* Logo */}
            <Link
              to={ROUTES.HOME}
              className="ms-logo-link"
            >
              <img
                src={logo}
                alt="MS Technologies"
                className="ms-logo-img"
              />
            </Link>

            {/* Navigation */}
            <div
              className={`header-nav-wrap ${expanded ? 'expanded' : ''
                }`}
            >
              <ul className="ms-nav-list">

                {/* Home First */}
                <li className="ms-nav-item">
                  <Link
                    to={ROUTES.HOME}
                    className={`ms-nav-link ${location.pathname === ROUTES.HOME
                      ? 'active'
                      : ''
                      }`}
                    onClick={() => setExpanded(false)}
                  >
                    Home
                  </Link>
                </li>

                {/* Solutions Dropdown */}
                <li
                  className="ms-nav-item ms-has-dropdown"
                  ref={solutionsRef}
                >
                  <button
                    type="button"
                    className={`ms-nav-link ms-nav-btn ${solutionsOpen ? 'open' : ''
                      }`}
                    onClick={() =>
                      setSolutionsOpen(!solutionsOpen)
                    }
                  >
                    Solutions
                    <i
                      className={`bi bi-chevron-down ms-nav-caret ${solutionsOpen ? 'rotated' : ''
                        }`}
                    />
                  </button>

                  <ul
                    className={`ms-dropdown-menu ${solutionsOpen ? 'visible' : ''
                      }`}
                  >
                    {solutionsItems.map((item) => (
                      <li key={item.id}>
                        <Link
                          to={item.path}
                          className="ms-dropdown-link"
                        >
                          <i className={`bi ${item.icon} ms-dd-icon`} />
                          <span>{item.label}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>

                {/* Remaining Menu */}
                {navLinks.map((link) => (
                  <li
                    key={link.label}
                    className="ms-nav-item"
                  >
                    <Link
                      to={link.path}
                      className={`ms-nav-link ${location.pathname === link.path
                        ? 'active'
                        : ''
                        }`}
                      onClick={() =>
                        setExpanded(false)
                      }
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}

              </ul>
            </div>

            {/* Right Side */}
            <div className="header-actions">
              <Link
                to={ROUTES.CONTACT}
                className={`ms-contact-btn ${location.pathname === ROUTES.CONTACT
                  ? 'active'
                  : ''
                  }`}
              >
                Contact us
              </Link>

              <button
                type="button"
                className={`ms-toggler ${expanded ? 'open' : ''
                  }`}
                onClick={() =>
                  setExpanded(!expanded)
                }
                aria-label="Toggle Navigation"
              >
                <span />
                <span />
                <span />
              </button>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;